export default __webpack_public_path__ + "static/media/logo_final_white.7f17ea7a.jpg";